export default __webpack_public_path__ + "static/1-175fe18598ef17a37a934e50b0c3a63b.jpg";